import { Loading, MessageBox, Message } from 'element-ui';
import { app } from '../main'


export const cloudLoading = () => {
    return Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
}

export const cloudConfirm = (options = {}) => {
    console.log(options);
    const {
        text = app.$t('alert_message.confirm_cancel'),
            confirmButtonText = app.$t('btns.confirm'),
            cancelButtonText = app.$t('btns.cancel'),
            showCancelToast = true
    } = options;

    return new Promise((resolve, reject) => {
        MessageBox.confirm(text, app.$t('alert_message.confirm_title'), {
            confirmButtonText,
            cancelButtonText,
            type: 'warning'
        }).then(() => {
            // Message({
            //     type: 'success',
            //     message: '删除成功!'
            // });
            resolve();
        }).catch(() => {
            if (showCancelToast) {
                Message({
                    type: 'info',
                    message: app.$t('alert_message.is_cancel')
                });
            }
            reject();
        });
    })
}

export const formatPrice = (value) => {
    let priceText = 0;
    if (value && value != 'undefined') priceText = value;
    const priceArr = String(priceText).split('');
    let price = '';
    priceArr.forEach((item, index) => {
        if (index >= 3 && index % 3 == 0) {
            price = priceArr[priceArr.length - index - 1] + ',' + price;
        } else {
            price = priceArr[priceArr.length - index - 1] + price;
        }
    })
    return '$' + price;
}

export const wait = (time = 500) => {
    return new Promise((res, rej) => {
        setTimeout(() => {
            res();
        }, time);
    })
}